/**
 * Gets environment variable value from runtime (window._env_) or build-time (process.env)
 * This allows the app to use environment variables set at runtime in Azure App Service
 */
export const getEnvVar = (key: string): string | undefined => {
  // First try to get from runtime environment (injected by inject-env.sh)
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key]
  }

  // Fallback to build-time environment variables
  return process.env[key]
}

/**
 * Gets environment variable value with a default fallback
 */
export const getEnvVarWithDefault = (
  key: string,
  defaultValue: string
): string => {
  return getEnvVar(key) ?? defaultValue
}
